import { Checkbox, Col, Row } from "antd";

import React, { useEffect, useState } from "react";
import { useTheme } from "../../../Styles/ThemeHook";
import { IC_Collapse } from "shared-components/Components/Collapse/web";
import {
    bathrooms,
} from "../../../ViewFragments/SearchResults/Sider/TopBarFilters/options"
import ButtonGroup from "../ButtonGroup/web";
import { Switch } from "src/Components/Swicth/web";
import { useFilters } from "../Filters.hook";

export const Bathrooms = ({ collapsable = false, inputType = "checkbox", filterChanged, triggerApplyFilter = undefined, show = false }) => {
	if (!show) return null;

	const { theme } = useTheme();
	const { filters } = useFilters();
	let filter = null;
	const [usingExactMode, setUsingExactMode] = useState<boolean>(filters?.bathroomsExactMode ?? false);
	const [currentValue, setCurrentValue] = useState(filters?.bathrooms ?? []);

	const normalizeFilterValues = (values) => {
		if (!Array.isArray(values)) return [];
		return values
			.map(item => (item && typeof item === "object" ? item.value : item))
			.filter(item => item !== undefined && item !== null);
	};

	const arraysAreEqual = (first = [], second = []) => {
		if (first === second) return true;
		if (first.length !== second.length) return false;
		return first.every((item, index) => second[index] === item);
	};

	useEffect(() => {
		const bathroomsValue = normalizeFilterValues(filters?.bathrooms);
		const normalizedCurrent = normalizeFilterValues(currentValue);

		if (!arraysAreEqual(bathroomsValue, normalizedCurrent)) {
			setCurrentValue(bathroomsValue);
		}

		const exactModeValue = filters?.bathroomsExactMode ?? false;
		if (exactModeValue !== usingExactMode) {
			setUsingExactMode(exactModeValue);
		}
	}, [filters?.bathrooms, filters?.bathroomsExactMode]);

	const handleChange = (value) => {
		const rawValues = Array.isArray(value)
			? value
			: value === undefined || value === null
				? []
				: [value];
		const sanitizedValues = rawValues.filter(item => item !== undefined && item !== null);

		if (sanitizedValues.length === 0) {
			handleClearFilter();
			return;
		}

		const valueSet = new Set(sanitizedValues.map(item => String(item)));
		const selectedOptions = bathrooms.filter(option => valueSet.has(String(option.value)));

		if (selectedOptions.length === 0) {
			handleClearFilter();
			return;
		}

		const selectedValues = selectedOptions.map(option => option.value);
		const dataOptions = selectedOptions.map(option => ({
			text: usingExactMode ? option.text : option.text.replace(/baños?/, "o más baños"),
			value: option.value
		}));

		setCurrentValue(selectedValues);
		handleApplyFilter({ bathrooms: dataOptions, bathroomsExactMode: { text: null, value: usingExactMode } });
	};

	const handleClearFilter = () => {
		if (currentValue.length === 0 && usingExactMode === false) {
			handleApplyFilter({ bathrooms: [], bathroomsExactMode: { text: null, value: false } });
			return;
		}

		setCurrentValue([]);
		setUsingExactMode(false);
		handleApplyFilter({ bathrooms: [], bathroomsExactMode: { text: null, value: false } });
	};

	const handleExactChange = (value) => {
		setUsingExactMode(value);
		handleApplyFilter({ bathroomsExactMode: {text: null, value} })

		if (!value) {
			handleClearFilter();
		};
	}

	const handleApplyFilter = (filter) => {
        if (triggerApplyFilter) triggerApplyFilter(filter);
        else filterChanged(filter)
    }

	if (!show) return null;

	if (inputType === "checkbox") {
		filter = (
			<Checkbox.Group value={currentValue} onChange={handleChange}>
				<Row gutter={[0, theme.spacing.lgSpacing]}>
					{bathrooms?.map(option => (
						<Col span={24} key={`key_${option.value}_bathrooms`}>
							<Checkbox value={option.value}>
								{option.text}
							</Checkbox>
						</Col>
					))}
				</Row>
			</Checkbox.Group>
		);
	} else {
		filter = (
			<>
				<div className="filter__scrollable-box">
					<ButtonGroup
						options={bathrooms.map(option => {return {text: option.smallText, value: option.value}})}
						selected={currentValue}
						allowMuliple={usingExactMode}
						onChange={handleChange} 
						cleanFilter={handleClearFilter}
						optionForAny={{text: 'Todos', value: null}}
						exactMode={usingExactMode}
					/>
				</div>

				<div className="filter__exact-mode">
					<span>Número exacto de baños</span>
					<Switch checked={usingExactMode} onChange={handleExactChange} />
				</div>

				<hr style={{width:"100%", border:'none', borderTop:'1px solid rgba(0,0,0,.06)', margin:'24px 0'}} />
			</>
		);
	}

	const label = "Baños";

	return (
		<div className={"filter bathrooms-filter"}>
			{collapsable ?
				<IC_Collapse label={label} isActive={currentValue?.length >= 1} startOpen={currentValue?.length >= 1}>
					{filter}
				</IC_Collapse> :
				<>
					{inputType === "buttonGroup" && <h3 className="filter-title">{label}</h3>}
					{filter}
				</>
			}
		</div>
	);
};
